import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./Pagination.scss";

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageCount: [...Array(Math.ceil(this.props.length / 8))],
      selectedPage: "1"
    };
  }

  pageClick(e) {
    e.preventDefault();
    if (e.target.firstChild.nodeValue) {
      this.setState({ selectedPage: e.target.firstChild.nodeValue });
    }
    if (e.target.firstChild.innerHTML) {
      this.setState({ selectedPage: e.target.firstChild.innerHTML });
    }
  }

  render() {
    return (
      <div className="pagination">
        <div className="pageHeader">Pages</div>
        {this.state.pageCount.map((item, index) => (
          <div
            key={index}
            onClick={e => {
              this.pageClick(e);
              this.props.onPageClick(parseInt(index + 1, this.state.pageCount))
            }}
            className={`pageDot${index + 1}`}
            style={
              this.state.selectedPage === `${parseInt(index + 1)}`
                ? { backgroundColor: "#5399C9", color: "white" }
                : { backgroundColor: "#596773" }
            }
          >
            <span>{index + 1}</span>
          </div>
        ))}
      </div>
    );
  }
}

export default withRouter(Pagination);
